import axios from "axios";
import moment from "moment";
const url = process.env.REACT_APP_API_BASE_URL;
const api_key = process.env.REACT_APP_API_KEY;
const lead_source = "Website";
const getCommonHeaders = () => {
  let headers = {};
  headers["X_TIMESTAMP"] = Math.round(new Date() / 1000);
  headers["X_FEATURES"] = "unknown";
  headers["X_APPID"] = "1";
  headers["X_APPVERSION"] = "1.0.0";
  headers["X_DEVICEID"] = "1";
  headers["X_DEVICEOS"] = "web";
  headers["X_APIKEY"] = process.env.REACT_APP_API_KEY;
  return headers;
};
const submitFormApi = async ({ campaign_id, data }) => {
  let payload_data = {
    payload: {
      ...data,
    },
  };
  try {
    let response = await axios({
      method: "post",
      url: `${url}external/campaigns/${campaign_id}/submit`,
      headers: {
        ...getCommonHeaders(),
      },
      data: payload_data,
    });
    return true;
  } catch (error) {
    return false;
  }
};

const openCampaignApi = async (campaign_id) => {
  try {
    let response = await axios({
      method: "post",
      url: `${url}external/campaigns/${campaign_id}/open`,
      headers: getCommonHeaders(),
    });
    return response.data;
  } catch (error) {
    return {};
  }
};

export { submitFormApi, openCampaignApi };
